import { CommonModule } from '@angular/common';
import { Component } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { NgbModal, NgbModalConfig, NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { NgxPaginationModule } from 'ngx-pagination';
import { SampleSearchPipe } from '../../../../core/pipes/sample-search.pipe';
import { LoadingComponent } from '../../../shared/loading/loading.component';
import { ToastrService } from 'ngx-toastr';
import { RoleService } from '../../../../core/services/role.service';
import { AppActionCheck } from '../../../../core/utils/app-action-check';
import { AppErrorShow } from '../../../../core/utils/app-error-show';
import { AppSweetAlert } from '../../../../core/utils/app-sweet-alert';
import { LocalStorageService } from '../../../../core/utils/local-stoarge-service';
import { TransfertService } from '../../../../core/services/transfert.service';
import { DashService } from '../../../../core/services/dash.service';
import { RouterModule } from '@angular/router';

@Component({
  selector: 'app-financial',
  standalone: true,
  imports: [
     CommonModule,
            FormsModule,
            NgbModule,
            NgxPaginationModule,
            LoadingComponent,
            SampleSearchPipe,
            RouterModule
  ],
  templateUrl: './financial.component.html',
  styleUrl: './financial.component.css'
})
export class FinancialComponent {
data:any[]=[]
loading=false
    constructor(
      private dashService:DashService,
      private toastrService:ToastrService,
        config: NgbModalConfig,
        private lsService:LocalStorageService,
      private modalService: NgbModal) {
       config.backdrop = 'static';
       config.keyboard = false;
       }


  ngOnInit(): void {
    this.getDash()
  }

  getDash(){
    this.loading=true

    this.dashService.getFinancialDash().subscribe((res:any)=>{
      this.data=res.data
      this.loading=false

    },
    (err:any)=>{
      this.loading=false

    })
  }
 }
